import React from "react";
import PropTypes from "prop-types";
import Datasheet from "react-datasheet";
import { OrderedMap } from "immutable";
import { 
    Card, 
    // Button, 
    // Icon 
} from "antd";
import { ObjectSelectEditor } from "components";
import { UI_LIST_ITEM_TYPES } from "constants";
import "styles/form.css";
import { BOOLEAN_OPTIONS, CASE_STATUS_TYPES } from "constants/enums";
const CASE_DETAIL_FIELDS = new OrderedMap({

    product: {
        label: "Product",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    bank: {
        label: "Bank",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    case_status: {
        label: "Case Status",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: CASE_STATUS_TYPES,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={CASE_STATUS_TYPES.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    },
    // seller_security_type: {
    //     label: "Seller Security Type",
    //     type: UI_LIST_ITEM_TYPES.LIST_ITEM,
    //     dataType: "OBJECT_SELECT",
    //     options: BOOLEAN_OPTIONS,
    //     component: (() => {
    //         const comp = props => (
    //             <ObjectSelectEditor
    //                 options={BOOLEAN_OPTIONS.map((_, k) => ({
    //                     label: k,
    //                     value: _
    //                 })).toList()}
    //                 style={
    //                     {width: "100%"}
    //                 }
    //                 labelProp={"label"}
    //                 {...props}
    //             />);
    //         comp.displayName= "DataSheetSelectEditor";
    //         return comp;
    //     })()
    // },
    date_of_appointment: {
        label: "Date Of Appointment",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    proposed_date_of_signing_agreement: {
        label: "Proposed Date of Signing Agreement",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM
    },
    kyc_docs_received: {
        label: "KYC Docs Recieved ?",
        type: UI_LIST_ITEM_TYPES.LIST_ITEM,
        dataType: "OBJECT_SELECT",
        options: BOOLEAN_OPTIONS,
        component: (() => {
            const comp = props => (
                <ObjectSelectEditor
                    options={BOOLEAN_OPTIONS.map((_, k) => ({
                        label: k,
                        value: _
                    })).toList()}
                    style={
                        {width: "100%"}
                    }
                    labelProp={"label"}
                    {...props}
                />);
            comp.displayName= "DataSheetSelectEditor";
            return comp;
        })()
    }
});

class CaseDetailsForm extends React.Component {
    state = {
        data: []
    };

    edit = true;
    componentDidMount() {
        this.edit = true;
        this.setState({
            data: this.generateCols()
        });
    }
    generateCols() {
        let grid = CASE_DETAIL_FIELDS
            .map((_, key) => {
                if(_.type === UI_LIST_ITEM_TYPES.SECTION) {
                    return [
                        {
                            value: _.label,
                            readOnly: true,
                            type: _.type,
                            colSpan: 2
                        }
                    ];
                }
                return [
                    {
                        value: _.label,
                        readOnly: true,
                        type: _.type
                    },
                    {
                        value: this.props.values &&
                            this.props.values[key] ? 
                            (
                                _.options ?
                                    typeof this.props.values[key] === "object" && this.props.values[key].length > 0 ?
                                        _.options.findKey(_ => _ === this.props.values[key][0]) :
                                        _.options.findKey(_ => _ === this.props.values[key]) :
                                    String(this.props.values[key])
                            ) : 
                            null,
                        type: _.type,
                        dataType: _.dataType,
                        itemKey: key,
                        dataEditor: _.component
                    }
                ];
            })
            .toList()
            .toArray();
        return grid;
    }

    handleCellChange = changes => {
        this.edit = true;
        this.saveActive = true;
        const grid = this.state.data.map(row => [...row]);
        changes.forEach(({ row, col, value }) => {
            let error = false;
            // if (
            //     value &&
            //     value.length > 0 &&
            //     isNaN(Number(value))
            // ) {
            //     error = true;
            //     this.saveActive = false;
            // }
            grid[row][col] = {
                ...grid[row][col],
                value,
                className: error ? "error-cell" : null
            };
        });
        this.setState({ data: grid });
    }

    cellRenderer = (cell) => {
        if(cell && cell.dataType === "SELECT") {
            return cell.value ? cell.options.findKey(_ => _ === cell.value) : "";
        }
        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && (cell.value.name || cell.value.label )) {
            return cell.value ? (cell.value.name ? cell.value.name : cell.value.label) : "";
        }

        if(cell && cell.dataType === "OBJECT_SELECT" && cell.value && typeof cell.value !== "string" && cell.value.length > 0) {
            return cell.value ? (cell.value.map(_ => _.name ? _.name : _.label).join("; ")) : "";
        }

        if(cell.value && cell.value._isAMomentObject) {
            return cell.value.format("DD-MM-YYYY");
        }

        if(cell.value && isNaN(cell.value)) {
            return cell.value;
        }
        if(!cell.value) {
            return "--";
        }
        return cell.value;
    }

    save = () => {
        this.saveActive = false;
        const obj = {};
        this.state.data
            .filter(_ => _[0].type === UI_LIST_ITEM_TYPES.LIST_ITEM)
            .map(([, v]) => {
                if(!v || !v.value || v.itemKey === "product") {
                    return;
                }
                obj[v.itemKey] = v && v.value && typeof v.value === "object" ? 
                    (v.value.length > 0  ? v.value.map(__ => (__.value || __.id)) : v.value["value"] ? v.value["value"] : v.value["id"]) :                   
                    v.value === "" ? 0 : 
                        typeof v.value === "string" ? 
                            v.value : Number(v.value);
            });
        const updatedCaseDetail = this.props.caseDetail.merge(obj);
        // const newCompanyProfile = this.props.caseDetail.withMutations(mut => {
        //     Object.keys(obj).map(_ => {
        //         console.log(_, obj[_]);
        //         mut.set(_, obj[_]);
        //     });    
        // });
        // console.log(this.props.caseDetail);
        this.props.updateCaseDetail(this.props.caseId, updatedCaseDetail);
    }

    render() {
        return (
            <React.Fragment>
                <Card
                    title={"Basic Case Details"}
                    className={"padless-card mb-10"}
                    // extra={[
                    //     <Button
                    //         key="action-save"
                    //         // disabled={!this.saveActive}
                    //         type={"link"}
                    //         onClick={this.save}
                    //     >
                    //         Save <Icon type={"save"} />
                    //     </Button>
                    // ]}
                >
                    <div className={"spreadsheet-table"}>
                        <Datasheet
                            data={this.state.data}
                            valueRenderer={(cell) => this.cellRenderer(cell)}
                            onCellsChanged={this.handleCellChange}
                        />
                    </div>
                </Card>
            </React.Fragment>
        );
    }

}

CaseDetailsForm.propTypes = {
    values: PropTypes.object,
    caseDetail: PropTypes.object,
    updateCaseDetail: PropTypes.func,
    caseId: PropTypes.number
};

export default CaseDetailsForm;